import { forwardRef } from "react";
import { SaveBar } from "@shopify/app-bridge-react";
import { isEmbeddedAdminFrame } from "../../app/components/SafeAppBridge";

type SettingsSaveBarProps = {
    open: boolean;
    saving: boolean;
    onSave: () => void;
    onDiscard: () => void;
};

const SettingsSaveBar = forwardRef<UISaveBarElement, SettingsSaveBarProps>(({ open, saving, onSave, onDiscard }, ref) => {
    if (isEmbeddedAdminFrame() && window.customElements?.get("ui-save-bar")) {
        return (
            <SaveBar ref={ref} id="storefront-settings-save-bar" open={open}>
                <button variant="primary" onClick={onSave} disabled={saving} loading={saving ? "" : undefined}>Save</button>
                <button onClick={onDiscard} disabled={saving}>Discard</button>
            </SaveBar>
        );
    }

    return (
        <div id="storefront-settings-save-bar" className="pf-settings-save-bar" hidden={!open}
            role="group" aria-label="Unsaved settings changes" aria-busy={saving}>
            <span className="pf-settings-save-bar__message" role="status">Unsaved changes</span>
            <div className="pf-settings-save-bar__actions">
                <button type="button" onClick={onDiscard} disabled={saving}>Discard</button>
                <button type="button" className="pf-settings-save-bar__save" onClick={onSave} disabled={saving}>
                    {saving ? "Saving…" : "Save"}
                </button>
            </div>
        </div>
    );
});

// App Bridge must recognize this direct modal child and keep it outside the
// content iframe so Shopify can render the actions in the native header.
SettingsSaveBar.displayName = "ui-save-bar";

export default SettingsSaveBar;

